<template>
  <v-dialog v-model="dialog" max-width="400" persistent>
    <template v-slot:activator="{ on, attrs }">
      <span v-on="on" v-bind="attrs">
        <v-text-field
          :items="items"
          :rules="rules"
          :label="label"
          :prepend-inner-icon="prependInnerIcon"
          :prepend-icon="prependIcon"
          :class="className"
          :outlined="outlined"
          :rounded="rounded"
          :dense="dense"
          :required="required"
          :value="selected.map(title).join(', ')"
          readonly
        />
      </span>
    </template>
    <v-card :loading="loading">
      <v-card-title class="pa-0">
        <v-text-field
          v-model="query"
          placeholder="Search"
          prepend-inner-icon="mdi-magnify"
          hint="Search with the keyword"
          persistent-hint
          hide-details
          filled
          dense
          flat
          background-color="white"
        />
      </v-card-title>
      <v-card-text
        class="pt-0 overflow-auto"
        v-if="filteredItems.length"
        style="max-height: 400px"
      >
        <v-checkbox
          v-for="item in filteredItems.slice(0, limit)"
          v-model="selected"
          :value="item"
          :key="uniqueKey ? item[uniqueKey] : item"
          hide-details
        >
          <template v-slot:label>
            {{ title(item) }}
          </template>
        </v-checkbox>
      </v-card-text>
      <v-alert dense text type="warning" v-else class="mb-0">
        Nothing found! Try someting else.
      </v-alert>
      <v-divider />
      <v-card-actions>
        <v-btn small text @click="close">Cancel</v-btn>
        <v-spacer />
        <v-btn small color="primary" @click="done">Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    search: {
      type: Function,
      default (item, query) {
        return item.toLowerCase().includes(query.toLowerCase())
      }
    },
    title: {
      type: Function,
      default (item) {
        return item
      }
    },
    limit: {
      type: Number,
      default: 20
    },
    loading: Boolean,
    value: Array,
    outlined: Boolean,
    required: Boolean,
    rounded: Boolean,
    dense: Boolean,
    label: String,
    rules: Array,
    uniqueKey: String,
    className: String,
    prependInnerIcon: String,
    prependIcon: String
  },
  computed: {
    filteredItems () {
      return this.items.filter((item) => this.search(item, this.query))
    }
  },
  data () {
    return {
      dialog: false,
      query: '',
      selected: []
    }
  },
  methods: {
    close () {
      this.query = ''
      this.dialog = false
      this.$emit('cancel')
    },
    done () {
      this.$emit('input', this.selected)
      this.close()
    },
    init () {
      if (this.value) {
        const array = this.uniqueKey
          ? this.value.map((item) => item[this.uniqueKey])
          : this.value

        this.selected = this.uniqueKey
          ? this.items.filter((item) => array.includes(item[this.uniqueKey]))
          : array
      }
    }
  },
  created () {
    this.init()
  }
}
</script>
